<template>
	<div>
		<layoutOld v-if="version == 1"></layoutOld>
	<layoutNew v-else></layoutNew>
	</div>
</template>
<script>
import layoutOld from './layoutOld.vue';
import layoutNew from './layoutNew.vue';

export default {
    components: {
        layoutOld,
        layoutNew
    },
	computed: {
		version() {
			return this.$store.state.user.version;
		}
	}
}
</script>
<style></style>